var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mypage-one-time-pass-input-pane"},[_c('one-time-pass-input-section',{on:{"onSaveOneTimePassUsage":_vm.saveOneTimePassUsageOnUser,"handlerSubmit":_vm.setOneTimePassPlanAndOnSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }